interface WorkSubNavProps {
  items: { id: string; label: string }[];
  activeId: string;
  onChange: (id: string) => void;
}

export function WorkSubNav({ items, activeId, onChange }: WorkSubNavProps) {
  return (
    <div className="flex gap-2 flex-wrap" role="tablist" aria-label="Sub-secções">
      {items.map((item) => {
        const isActive = item.id === activeId;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(item.id)}
            className={`px-4 py-2 rounded transition-colors text-sm border ${
              isActive
                ? "bg-primary/10 text-primary border-primary/20"
                : "bg-secondary hover:bg-accent border-border text-foreground"
            }`}
            style={{
              borderRadius: "var(--radius-button)",
              fontWeight: isActive
                ? "var(--font-weight-semi-bold)"
                : "var(--font-weight-normal)",
            }}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
